import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Button,
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  InputAdornment,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ClearIcon from "@mui/icons-material/Clear";
import { LoadingButton } from "@mui/lab";
import axiosInstance from "../../Api/axios.instance";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

const EDIT_FIELDS = [
  "TeachersDesignationId",
  "CertificateId",
  "QualificationId",
  "TeacherName",
  "TeacherNameUrdu",
  "FirstSalary",
  "Allowance",
  "CNIC",
  "DateJoining",
  "DateLeft",
  "ContactNo",
  "TeacherCode",
  "DateOfBirth",
  "MaritalStatus",
  "ExperienceOfTeaching",
  "SubjectOfExperience",
  "HiredSubject",
  "ReasonForLeaving",
  "LeftStatus",
  "WarningStatus",
  "SalaryDemand",
  "BankAccount",
  "IsPrimary",
  "TypeOfHiring",
  "Address",
  "DataEntryOperator",
  "DateDataEntry",
];

export default function TeacherLeft({
  leftStaff,
  refreshLeftStaff,
  refreshStaff,
}) {
  const [leftStaffArray, setLeftStaffArray] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const openAnchor = Boolean(anchorEl);

  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [reasonOptions, setReasonOptions] = useState([]);

  useEffect(() => {
    const sorted = [...leftStaff].sort((a, b) => {
      if (!a.DateLeft) return 1;
      if (!b.DateLeft) return -1;
      const dateDiff = new Date(b.DateLeft) - new Date(a.DateLeft);
      if (dateDiff !== 0) return dateDiff;

      const desigA = a.Designation?.TeachersDesignationId ?? 999;
      const desigB = b.Designation?.TeachersDesignationId ?? 999;
      return desigA - desigB;
    });
    setLeftStaffArray(sorted);
  }, [leftStaff]);

  useEffect(() => {
    const _fetchReasons = async () => {
      try {
        const { data } = await axiosInstance.get(
          "/variables/reason-for-leaving",
        );
        setReasonOptions(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    _fetchReasons();
  }, []);

  const formatDate = (date) => {
    if (!date) return "Not Defined";
    return dayjs(date).format("DD-MM-YYYY");
  };

  const handleAnchorClose = () => setAnchorEl(null);

  const handleIconClick = (row) => (event) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleEditOpen = () => {
    setEditData({ ...selectedRow });
    setOpenEdit(true);
    handleAnchorClose();
  };

  const handleEditClose = () => {
    setOpenEdit(false);
    setEditData({});
  };

  const _handleEditChange = (e) => {
    setEditData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const _handleDateLeftChange = (newValue) => {
    const formatted = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;
    setEditData((prev) => ({
      ...prev,
      DateLeft: formatted,
      ...(formatted ? {} : { ReasonForLeaving: null, LeftStatus: null }),
    }));
  };

  const _mapIsPrimary = (val) => {
    if (val === true || val === 1 || val === "Primary") return "Primary";
    if (val === false || val === 0 || val === "Secondary") return "Secondary";
    if (val === 2 || val === "2" || val === "KG") return "KG";
    return "";
  };

  const _onEditSubmit = async () => {
    try {
      const formData = new FormData();
      EDIT_FIELDS.forEach((f) => {
        let value = editData[f] ?? "";
        if (f === "ContactNo") {
          value = String(value).trim();
        } else if (f === "IsPrimary") {
          value = _mapIsPrimary(editData.IsPrimary);
        }
        formData.append(f, value);
      });

      const { status } = await axiosInstance.put(
        `/teachers/${editData.SchoolTeachersQId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      if (status === 200) {
        handleEditClose();
        if (refreshLeftStaff) refreshLeftStaff();
        if (refreshStaff) refreshStaff();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isReactivating = !editData.DateLeft;

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="left teacher table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Full Name</TableCell>
            <TableCell align="center">School</TableCell>
            <TableCell align="center">Designation</TableCell>
            <TableCell align="center">CNIC</TableCell>
            <TableCell align="center">Left Status</TableCell>
            <TableCell align="center">Reason for Leaving</TableCell>
            <TableCell align="center">Date Left</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leftStaffArray.length > 0 ? (
            leftStaffArray.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {row.TeacherName || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.School?.NameOfSchool || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.Designation?.TeachersDesignation || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.CNIC || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.LeftStatus || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.ReasonForLeaving || "Not Defined"}
                </TableCell>
                <TableCell align="center">{formatDate(row.DateLeft)}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={handleIconClick(row)}>
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center">
                No left teachers.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <Menu
        id="left-teacher-menu"
        anchorEl={anchorEl}
        open={openAnchor}
        onClose={handleAnchorClose}
        MenuListProps={{ "aria-labelledby": "left-teacher-button" }}
      >
        <MenuItem onClick={handleEditOpen}>Edit</MenuItem>
      </Menu>

      <Dialog fullWidth maxWidth="sm" open={openEdit} onClose={handleEditClose}>
        <DialogTitle>Edit Left Teacher</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  label="Date Left"
                  inputFormat="DD-MM-YYYY"
                  value={editData.DateLeft || null}
                  onChange={_handleDateLeftChange}
                  componentsProps={{
                    actionBar: { actions: ["clear", "accept"] },
                  }}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      size="small"
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: editData.DateLeft ? (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              edge="end"
                              onClick={(e) => {
                                e.stopPropagation();
                                _handleDateLeftChange(null);
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ) : (
                          params.InputProps?.endAdornment
                        ),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="CNIC"
                fullWidth
                size="small"
                name="CNIC"
                value={editData.CNIC || ""}
                onChange={(e) =>
                  setEditData((prev) => ({
                    ...prev,
                    CNIC: e.target.value.replace(/\D/g, ""),
                  }))
                }
                inputProps={{ maxLength: 13 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                label="Reason for Leaving"
                fullWidth
                size="small"
                name="ReasonForLeaving"
                value={editData.ReasonForLeaving || ""}
                onChange={_handleEditChange}
                disabled={isReactivating}
              >
                {reasonOptions.map((r) => (
                  <MenuItem key={r.ID} value={r.Caption}>
                    {r.Caption}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                label="Left Status"
                fullWidth
                size="small"
                name="LeftStatus"
                value={editData.LeftStatus || ""}
                onChange={_handleEditChange}
                disabled={isReactivating}
              >
                <MenuItem value="Resigned">Resigned</MenuItem>
                <MenuItem value="Terminated">Terminated</MenuItem>
                <MenuItem value="Retired">Retired</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose}>Cancel</Button>
          <LoadingButton onClick={_onEditSubmit} variant="contained">
            Save
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </TableContainer>
  );
}
